const SANTA_NAMES = [
  'santa claus',
  'papa noel',
  'pere noel',
  'father christmas',
  'saint nicholas',
  'st nicholas',
  'san nicolas',
  'kris kringle',
  'sinterklaas',
  'babbo natale',
  'weihnachtsmann',
  'ded moroz',
  'pai natal',
];

const normalizeName = (name: string): string => {
  return name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
};

export const isSantaContact = (name: string): boolean => {
  if (!name) return false;
  const normalized = normalizeName(name);
  return SANTA_NAMES.includes(normalized);
};
